import { compact } from 'lodash-es';
import { relationshipModel } from "../../models";
// ============ Enums ============

export let PreviewState = /*#__PURE__*/function (PreviewState) {
  PreviewState["Preview"] = "preview";
  PreviewState["SetupBrand"] = "setupBrand";
  return PreviewState;
}({});
export let COBStep = /*#__PURE__*/function (COBStep) {
  COBStep["welcome"] = "welcome";
  COBStep["selectAPackage"] = "packages";
  COBStep["reviewServices"] = "services";
  COBStep["termsOfService1"] = "terms-of-service-1";
  COBStep["termsOfService2"] = "terms-of-service-2";
  COBStep["termsOfService3"] = "terms-of-service-3";
  COBStep["termsOfService4"] = "terms-of-service-4";
  COBStep["approveTerms"] = "terms";
  COBStep["accountantAccess"] = "accountant-access";
  COBStep["paymentMethod"] = "payment-method";
  COBStep["introVideo"] = "intro-video";
  COBStep["allSet"] = "all-set";
  COBStep["introduction"] = "introduction";
  return COBStep;
}({});
export const termsOfServiceStepIndex = {
  [COBStep.termsOfService1]: 0,
  [COBStep.termsOfService2]: 1,
  [COBStep.termsOfService3]: 2,
  [COBStep.termsOfService4]: 3
};

// ============ Types ============

// ============ Shared Functions ============

export function getStepName(step, relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
  const getTermsOfServiceName = index => {
    var _relationship$legalTe;
    if (((_relationship$legalTe = relationship.legalTermsDocuments) === null || _relationship$legalTe === void 0 ? void 0 : _relationship$legalTe.length) > 1) {
      var _relationship$legalTe2, _relationship$legalTe3;
      return "Review ".concat((_relationship$legalTe2 = (_relationship$legalTe3 = relationship.legalTermsDocuments) === null || _relationship$legalTe3 === void 0 || (_relationship$legalTe3 = _relationship$legalTe3[index]) === null || _relationship$legalTe3 === void 0 ? void 0 : _relationship$legalTe3.displayName.replace(/\.pdf$/i, '')) !== null && _relationship$legalTe2 !== void 0 ? _relationship$legalTe2 : '');
    }
    return "Review Terms of Service";
  };
  switch (step) {
    case COBStep.welcome:
    case COBStep.introduction:
      return 'Introduction';
    case COBStep.selectAPackage:
      return 'Select a Package';
    case COBStep.reviewServices:
      return 'Review Services';
    case COBStep.approveTerms:
      return MULTIPLE_LEGAL_TERMS_DOCUMENTS ? 'Review Additional Terms' : 'Review Terms';
    case COBStep.accountantAccess:
      return 'Grant Accountant Access';
    case COBStep.paymentMethod:
      return 'Add a Payment Method';
    case COBStep.allSet:
      return "You're all set!";
    case COBStep.introVideo:
      return 'Welcome video';
    case COBStep.termsOfService1:
      return getTermsOfServiceName(0);
    case COBStep.termsOfService2:
      return getTermsOfServiceName(1);
    case COBStep.termsOfService3:
      return getTermsOfServiceName(2);
    case COBStep.termsOfService4:
      return getTermsOfServiceName(3);
  }
}

/**
 * Returns the common middle steps (between welcome/introduction and allSet) based on relationship configuration.
 * This is shared between V1 and V2 client onboarding flows.
 */
export function getCommonReachableSteps(relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
  var _relationship$legalTe4, _relationship$legalTe5;
  const hasPaymentMethod = relationship.requirePaymentMethod || relationship.isSample;
  const hasPackages = !!relationship.serviceBundles;
  const termsOfServiceSteps = MULTIPLE_LEGAL_TERMS_DOCUMENTS ? [COBStep.termsOfService1, COBStep.termsOfService2, COBStep.termsOfService3, COBStep.termsOfService4] : [];
  const termsOfServiceCount = (_relationship$legalTe4 = (_relationship$legalTe5 = relationship.legalTermsDocuments) === null || _relationship$legalTe5 === void 0 ? void 0 : _relationship$legalTe5.length) !== null && _relationship$legalTe4 !== void 0 ? _relationship$legalTe4 : 0;
  while (termsOfServiceSteps.length > termsOfServiceCount) {
    termsOfServiceSteps.pop();
  }
  return compact([relationshipModel.hasIntroVideos(relationship) && COBStep.introVideo, hasPackages && COBStep.selectAPackage, COBStep.reviewServices, ...termsOfServiceSteps, COBStep.approveTerms, hasPaymentMethod && COBStep.paymentMethod]);
}